import React from 'react';

import Circle from 'components/circle';
import RichText from 'components/rich-text';

import { ReactComponent as Icon01 } from 'svg/about-01.svg';
import { ReactComponent as Icon02 } from 'svg/about-02.svg';
import { ReactComponent as Icon03 } from 'svg/about-03.svg';

import './style.css';

const AboutServices = () => {
  return (
    <section className="services">
      <Circle
        className="about-circle-02"
        width="800px"
        angle={210}
        distance={32}
        blur={16}
      />
      <ul className="services-icons">
        <li>
          <Icon01 className="about-icon" />
          <h4>Questionnaire</h4>
        </li>

        <li>
          <Icon02 className="about-icon" />
          <h4>Analysis</h4>
        </li>
        <li>
          <Icon03 className="about-icon" />
          <h4>Results</h4>
        </li>
      </ul>

      <RichText>
        <p>
          The Tweak+ process begins with a detailed questionnaire so that you
          can tell us about your current situation on your own time. With your
          story in mind, we carefully review and process the information
          provided, and approach you with the prospective next steps that can
          lead you to success..
        </p>
        <p>
          Tweak+ is always simple, and always successful. No one knows your
          business better than you; With your transparency and accuracy, we’ll
          have everything we need to turn your questionnaire responses into
          definitive solutions.
        </p>
      </RichText>
      <div className="target" />
    </section>
  );
};
export default AboutServices;
